module.exports = __webpack_public_path__ + "img/cert3-small.65b1fb6c.jpg";